import React from 'react';
import PropTypes from 'prop-types';

import { StatusBarWrapper } from './css';
import Desktop from './desktop';

const StatusBar = ({
  isFormTouched,
  isFormValidated,
  dueMonthly,
  dueNow,
  onSaveAndExit,
  onSubmit,
  formErrors,
  hidePricing
}) => {
  const getPrice = amount => `$${amount.toFixed(2)}`;

  return (
    <StatusBarWrapper>
      <div id="footer-wrapper">
        <Desktop
          isFormTouched={isFormTouched}
          isFormValidated={isFormValidated}
          dueMonthly={getPrice(dueMonthly)}
          dueNow={getPrice(dueNow)}
          onSaveAndExit={onSaveAndExit}
          onSubmit={onSubmit}
          hidePricing={hidePricing}
          formErrors={formErrors}
        />
      </div>
    </StatusBarWrapper>
  );
};

StatusBar.propTypes = {
  isFormTouched: PropTypes.bool.isRequired,
  isFormValidated: PropTypes.bool.isRequired,
  dueMonthly: PropTypes.number,
  dueNow: PropTypes.number,
  onSaveAndExit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  hidePricing: PropTypes.bool,
  formErrors: PropTypes.shape({}).isRequired
};

StatusBar.defaultProps = {
  dueMonthly: 0,
  dueNow: 0,
  hidePricing: false
};

export default StatusBar;
